"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The AccountSource model module.
 * @module model/AccountSource
 * @version 3.0
 */
var AccountSource = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>AccountSource</code>.
   * @alias module:model/AccountSource
   */
  function AccountSource() {
    _classCallCheck(this, AccountSource);
    AccountSource.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(AccountSource, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>AccountSource</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountSource} obj Optional instance to populate.
     * @return {module:model/AccountSource} The populated <code>AccountSource</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new AccountSource();
        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient["default"].convertToType(data['id'], 'Number');
        }
        if (data.hasOwnProperty('key')) {
          obj['key'] = _ApiClient["default"].convertToType(data['key'], 'String');
        }
        if (data.hasOwnProperty('primaryIdentifier')) {
          obj['primaryIdentifier'] = _ApiClient["default"].convertToType(data['primaryIdentifier'], 'String');
        }
        if (data.hasOwnProperty('additionalInfo')) {
          obj['additionalInfo'] = _ApiClient["default"].convertToType(data['additionalInfo'], 'String');
        }
        if (data.hasOwnProperty('technical')) {
          obj['technical'] = _ApiClient["default"].convertToType(data['technical'], 'Boolean');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountSource</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountSource</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['key'] && !(typeof data['key'] === 'string' || data['key'] instanceof String)) {
        throw new Error("Expected the field `key` to be a primitive type in the JSON string but got " + data['key']);
      }
      // ensure the json data is a string
      if (data['primaryIdentifier'] && !(typeof data['primaryIdentifier'] === 'string' || data['primaryIdentifier'] instanceof String)) {
        throw new Error("Expected the field `primaryIdentifier` to be a primitive type in the JSON string but got " + data['primaryIdentifier']);
      }
      // ensure the json data is a string
      if (data['additionalInfo'] && !(typeof data['additionalInfo'] === 'string' || data['additionalInfo'] instanceof String)) {
        throw new Error("Expected the field `additionalInfo` to be a primitive type in the JSON string but got " + data['additionalInfo']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} id
 */
AccountSource.prototype['id'] = undefined;

/**
 * @member {String} key
 */
AccountSource.prototype['key'] = undefined;

/**
 * @member {String} primaryIdentifier
 */
AccountSource.prototype['primaryIdentifier'] = undefined;

/**
 * @member {String} additionalInfo
 */
AccountSource.prototype['additionalInfo'] = undefined;

/**
 * @member {Boolean} technical
 */
AccountSource.prototype['technical'] = undefined;
var _default = exports["default"] = AccountSource;